<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Name</th>
        <th>Message</th>
        <th>Gender</th>
        <th>Options</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(each, index) in menus" :key="index">
        <td>{{each.name}}</td>
        <td>{{each.message}}</td>
        <td>{{each.gender}}</td>
        <td>{{getOptionsText(each.options)}}</td>
        <td><i class="fa fa-pencil" v-on:click="editMenu(index)" title="Edit" aria-hidden="true"></i></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'AllMenu',
  computed: mapState({
    menus: state => state.menu.menus
  }),
  methods: {
    /**
     * @description get the option text for all options
     * @param {object[]} options array of the option configuration
     */
    getOptionsText (options) {
      return options.map(each => each.eng).join(', ')
    },
    ...mapActions(['getAllMenus', 'editMenu'])
  },
  mounted () {
    this.getAllMenus()
  }
}
</script>




// WEBPACK FOOTER //
// all.vue?137eb34b